import { FC, MouseEventHandler, useState } from "react";
import {
  Banner,
  ButtonWO,
  Input,
  PageContainer,
  PageWrapper,
  Paragraph,
  SubHeading,
  ErrorText,
  Modal,
  ModalContent,
  InputSmall,
  ButtonSmallBlue,
} from "../shared.styled";
import logo from "../../assets/images/logo.svg";
import { post } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { ForgotPWButton } from "../setup/login.styled";

const Login: FC = (): JSX.Element => {
  const [password, setPassword] = useState<string>("");
  const [showPWReset, setShowPWReset] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [PWReset, setPWReset] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [resetError, setResetError] = useState<string>("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    try {
      const authResp = await post("/auth/login", { password, email });
      localStorage.setItem("token", authResp.data.token);
      navigate("/setup");
    } catch (error) {
      setError(
        "Sorry, we couldn't find an account with that email and password."
      );
    }
  };

  const resetPW = async () => {
    try {
      console.log(email);
      await post("/auth/reset-password", { email });
      setPWReset(true);
    } catch (error) {
      setPWReset(false);
      setResetError("Sorry, there was a problem resetting your password.");
    }
  };

  return (
    <PageWrapper>
      {showPWReset && (
        <Modal onClick={() => setShowPWReset(false)}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <SubHeading style={{ color: "#222" }}>Reset Password</SubHeading>
            {PWReset ? (
              <Paragraph style={{ color: "#222" }}>
                Password reset email sent.
              </Paragraph>
            ) : (
              <>
                <Paragraph style={{ color: "#222" }}>
                  Enter your email address and we'll send you a link to reset
                  your password.
                </Paragraph>
                {resetError && <ErrorText>{resetError}</ErrorText>}
                <InputSmall
                  value={email}
                  placeholder="Email address"
                  type="email"
                  onChange={(e) => {setEmail(e.target.value)}}
                />
                <ButtonSmallBlue onClick={resetPW}>
                  Reset Password
                </ButtonSmallBlue>
              </>
            )}
          </ModalContent>
        </Modal>
      )}
      <PageContainer style={{ textAlign: "center" }}>
        <Banner>
          <img src={logo} alt="logo" width="260" />
        </Banner>
        <SubHeading>Login</SubHeading>
        <Paragraph></Paragraph>
        {error && <ErrorText>{error}</ErrorText>}
        <Input
          placeholder="Email address"
          type="text"
          onChange={(e) => setEmail(e.target.value)}
        />
        <Input
          placeholder="Password"
          type="password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <ButtonWO onClick={handleSubmit}>Login</ButtonWO>
        <ForgotPWButton onClick={() => setShowPWReset(true)}>
          Forgot your password?
        </ForgotPWButton>
      </PageContainer>
    </PageWrapper>
  );
};

export default Login;
